const DASHBOARD_BLOCKED_ACCOUNT_IDS: string[] = (() => {
  const raw = import.meta.env.VITE_DASHBOARD_BLOCKED_ACCOUNT_IDS;
  if (!raw) return [];
  return raw.split(',').map((id: string) => id.trim()).filter(Boolean);
})();

export function canAccessDashboards(user?: { accountId?: string; role?: string } | null): boolean {
  if (!user) return false;
  if (user.role === 'root') return true;
  const accountId = user.accountId || '';
  if (!accountId) return false;
  return !DASHBOARD_BLOCKED_ACCOUNT_IDS.includes(accountId);
}
